// The ad template catalog (M20). TEMPLATES = what the picker shows (the 5 style families + M21 Ideas + M21b Generic); the M14
// set is kept as CLASSIC_TEMPLATES (hidden) so an ad saved from one still opens; templateById looks in all.
import type { TemplateDef } from './dsl';
import { FAMILY_TEMPLATES } from './families';
import { IDEAS_TEMPLATES } from './ideas';
import { IDEAS_TEMPLATES_2 } from './ideas2';
import { GENERIC_TEMPLATES } from './generic';
import { CLASSIC_TEMPLATES } from './library';

export const TEMPLATES: TemplateDef[] = [
  ...FAMILY_TEMPLATES,
  ...GENERIC_TEMPLATES,
  ...IDEAS_TEMPLATES,
  ...IDEAS_TEMPLATES_2,
];
export { CLASSIC_TEMPLATES };
export const ALL_TEMPLATES: TemplateDef[] = [...TEMPLATES, ...CLASSIC_TEMPLATES];
